var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMouse(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#03142a;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_8",
    "data-name": "Layer 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mouse"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.69,9h-.41v4.88h4.47v-.82a4.12,4.12,0,0,0-.31-1.55,4,4,0,0,0-2.2-2.2A4.12,4.12,0,0,0,16.69,9ZM15.47,9h-.41A4.06,4.06,0,0,0,11,13.06v.82h4.47ZM11,17.94A4.06,4.06,0,0,0,15.06,22h1.63a4.12,4.12,0,0,0,1.55-.31,4,4,0,0,0,2.2-2.2,4.12,4.12,0,0,0,.31-1.55V14.69H11Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouse);
export default __webpack_public_path__ + "static/media/mouse.42d99f87060f6bcf7354e0890efda9cb.svg";
export { ForwardRef as ReactComponent };